<ds-phone-input
  class="w-100"
  [formControl]="formControl"
  [label]="props.label || 'Phone number'"
  [helper]="helper"
  [error]="error"
  [inputId]="id"
/>
<formly-validation-message *ngIf="showError" class="d-none" [field]="field" />
